import * as React from "react";
import { forwardRef } from "react";
const SvgChevron = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11.3334 6.66667L8.00004 10L4.66671 6.66667", stroke: "#818288", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgChevron);
export { ForwardRef as ReactComponent };
